module.exports = __webpack_public_path__ + "static/img_reciclaje-af04d951eaea3fb3cf8c7039f1c9e09a.png";